 <template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.carga_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos
              <i class="fa fa-file"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.carga_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Pedidos
              <i class="fa fa-file-text"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.carga_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Unid. Carga
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.carga_id + ''"
            v-if="rowData.obs !== null"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Obs.
              <i class="fa fa-comment"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.carga_id + ''"
            v-if="rowData.ocorrencias.length > 0"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Ocorrências
              <i class="fa fa-exclamation-triangle"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t6' + rowData.carga_id + ''"
            v-if="
              rowData.carga_rota !== null &&
              rowData.carga_rota.carga_rota_pedagio.length > 0
            "
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Pedágios
              <i class="fa fa-map-signs"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t7' + rowData.carga_id + ''"
            v-if="rowData.despesa_carga !== null"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Adiantamentos
              <i class="fa fa-money"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.carga_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N. Fiscal</th>
                <th style="width: 5%">Valor NF</th>
                <th style="width: 20%">Razão social emitente</th>
                <th style="width: 20%">Endereço emitente</th>
                <th style="width: 20%">Razão social destinatário</th>
                <th style="width: 20%">Endereço emitente</th>
                <th style="width: 5%">Data emissão</th>
                <th style="width: 5%">Número carga tracking</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.carga_doc"
              >
                <td>
                  <span
                    v-b-tooltip.hover.rightbottom
                    :title="'Chave : ' + item.doc_fiscal.chave"
                  >
                    {{ item.doc_fiscal.num_fiscal }}
                  </span>
                </td>
                <td>
                  <span
                    v-b-tooltip.hover.rightbottom
                    :title="'Id trn : ' + item.doc_fiscal.pessoa_id_trn"
                  >
                    {{
                      formatNumber(
                        item.doc_fiscal.doc_fiscal_vlr_total.vlr_total_nfe
                      )
                    }}
                  </span>
                </td>
                <td>
                  {{ item.doc_fiscal.doc_fiscal_partes_env.emi_nome }}
                </td>
                <td>
                  {{ item.doc_fiscal.doc_fiscal_partes_env.emi_endereco }} -
                  {{ item.doc_fiscal.doc_fiscal_partes_env.emi_nome_municipio }}
                  - {{ item.doc_fiscal.doc_fiscal_partes_env.emi_uf }}
                </td>
                <td>
                  {{ item.doc_fiscal.doc_fiscal_partes_env.des_nome }}
                </td>
                <td>
                  {{ item.doc_fiscal.doc_fiscal_partes_env.des_endereco }} -
                  {{ item.doc_fiscal.doc_fiscal_partes_env.des_nome_municipio }}
                  - {{ item.doc_fiscal.doc_fiscal_partes_env.des_uf }}
                </td>
                <td>
                  {{ formatDate(item.doc_fiscal.dt_emissao) }}
                </td>
                <td>
                  <span v-if="item.doc_fiscal.doc_fiscal_tracking != null">
                    {{ item.doc_fiscal.doc_fiscal_tracking.num_carga }}
                  </span>
                  <span v-if="item.doc_carga_doc.doc.manifesto_doc != null">
                    {{
                      item.doc_carga_doc.doc.manifesto_doc.manifesto
                        .num_carga_itrack
                    }}
                  </span>
                </td>
                <td>
                  <a
                    @click="onVinculaOcorrencia(item, 1)"
                    v-b-tooltip
                    title="Vincular Ocorrência"
                    ><i class="fa fa-exclamation-triangle"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t2' + rowData.carga_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">N. Pedido</th>
                <th style="width: 50%">Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.pedidos_carga"
              >
                <td>
                  {{ item.num_pedido }}
                </td>
                <td>
                  {{ item.descr }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t3' + rowData.carga_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">Unidade Carga</th>
                <th style="width: 30%">Status</th>
                <th style="width: 40%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in rowData.carga_unidade_carga">
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    {{ item.num_uc }}
                  </td>
                  <td>
                    {{ item.status }}
                  </td>
                  <td>
                    <a
                      @click="onVinculaOcorrencia(item, 2)"
                      v-b-tooltip
                      title="Vincular Ocorrência"
                      ><i class="fa fa-exclamation-triangle"></i
                    ></a>
                    <a
                      @click="onVinculaTrecho(item)"
                      v-b-tooltip
                      title="Adicionar Trecho"
                      ><i class="fa fa-map-marker"></i
                    ></a>
                    <a
                      @click="onDetailUnidadeCargaTrecho(item.pedunicar_id)"
                      v-if="item.pedido_unidade_carga_trecho.length > 0"
                      v-b-tooltip
                      title="Ver detalhes"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="isVisibleDetailRowTrecho(item.pedunicar_id)">
                  <td colspan="9">
                    <section class="tabs-section">
                      <ul
                        class="nav nav-tabs nav-topline nav-justified"
                        role="tablist"
                      >
                        <li class="nav-item">
                          <a
                            class="nav-link active"
                            v-bind:href="'#tr1' + item.pedunicar_id + ''"
                            role="tab"
                            data-toggle="tab"
                          >
                            <span class="nav-link-in">
                              Trechos
                              <i class="fa fa-map-marker"></i>
                            </span>
                          </a>
                        </li>
                      </ul>
                      <div class="tab-content">
                        <div
                          role="tabpanel"
                          class="
                            tab-pane
                            fade
                            in
                            active
                            show
                            pt-1
                            border-color-detalhes-grey
                          "
                          v-bind:id="'tr1' + item.pedunicar_id + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th style="width: 10%">Nº Trecho</th>
                                <th style="width: 5%">Ordem/Principal</th>
                                <th style="width: 5%">Tipo Trecho</th>
                                <th style="width: 10%">Tipo Custo</th>
                                <th style="width: 15%">Modal</th>
                                <th style="width: 13%">Município Início</th>
                                <th style="width: 12%">Municipio Fim</th>
                                <th style="width: 15%">Fornecedor</th>
                                <th style="width: 5%">Status</th>
                                <th style="width: 5%">Ações</th>
                              </tr>
                            </thead>
                            <tbody
                              v-for="item_trecho in item.pedido_unidade_carga_trecho"
                            >
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  {{ item_trecho.num_trecho }}
                                </td>
                                <td>
                                  {{ item_trecho.ordem }} -
                                  <span
                                    class="badge badge-success"
                                    v-if="item_trecho.principal.valor == 1"
                                    >{{ item_trecho.principal.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_trecho.principal.valor == 2"
                                    >{{ item_trecho.principal.descr }}</span
                                  >
                                </td>
                                <td>
                                  {{ item_trecho.tp_trecho.descr }}
                                </td>
                                <td>
                                  <span
                                    class="badge badge-success"
                                    v-if="item_trecho.tp_custo.valor == 1"
                                    >{{ item_trecho.tp_custo.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_trecho.tp_custo.valor == 2"
                                    >{{ item_trecho.tp_custo.descr }}</span
                                  >
                                </td>
                                <td>
                                  {{ item_trecho.b_modal.descr }}
                                </td>
                                <td>
                                  {{ item_trecho.municipio_inicio.nome }}
                                </td>
                                <td>
                                  {{ item_trecho.municipio_fim.nome }}
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      item_trecho.fornecedor !== null &&
                                      item_trecho.fornecedor.pessoa_juridica !==
                                        null
                                    "
                                    >{{
                                      onFormataCnpj(
                                        item_trecho.fornecedor.pessoa_juridica
                                          .cnpj_base,
                                        item_trecho.fornecedor.pessoa_juridica
                                          .cnpj_filial,
                                        item_trecho.fornecedor.pessoa_juridica
                                          .cnpj_digito
                                      )
                                    }}
                                    -
                                    {{
                                      item_trecho.fornecedor.pessoa_juridica
                                        .razao_social
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      item_trecho.fornecedor !== null &&
                                      item_trecho.fornecedor.pessoa_fisica !==
                                        null
                                    "
                                    >{{
                                      item_trecho.fornecedor.pessoa_fisica.nome
                                    }}
                                    -
                                    {{
                                      item_trecho.fornecedor.pessoa_fisica.cpf
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      item_trecho.fornecedor !== null &&
                                      item_trecho.fornecedor.pessoa_exterior !==
                                        null
                                    "
                                    >{{
                                      item_trecho.fornecedor.pessoa_exterior
                                        .nome
                                    }}
                                    -
                                    {{
                                      item_trecho.fornecedor.pessoa_exterior
                                        .cuit
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    class="badge badge-dark"
                                    v-if="item_trecho.status.valor == 1"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-info"
                                    v-if="item_trecho.status.valor == 2"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-warning"
                                    v-if="item_trecho.status.valor == 3"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-success"
                                    v-if="item_trecho.status.valor == 4"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                  <span
                                    class="badge badge-danger"
                                    v-if="item_trecho.status.valor == 5"
                                    >{{ item_trecho.status.descr }}</span
                                  >
                                </td>
                                <td>
                                  <a
                                    @click="onAlteraFornecedor(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.fornecedor.update'
                                      ) ||
                                      getPermissionFw(
                                        'gerenciamentotransporte.fornecedor.store'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Alterar Fornecedor"
                                    ><i class="fa fa-user"></i
                                  ></a>
                                  <a
                                    @click="onAlteraStatus(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.trecho.status'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Alterar Status"
                                    ><i class="fa fa-cogs"></i
                                  ></a>
                                  <a
                                    @click="onVinculaCusto(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.custo.store'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Vincular Custo"
                                    ><i class="fa fa-tasks"></i
                                  ></a>
                                  <a
                                    @click="onPrintMinuta(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.custo.store'
                                      ) &&
                                      item_trecho.tp_custo.valor == 2 &&
                                      item_trecho.pedido_unidade_carga_tre_custo
                                        .length > 0
                                    "
                                    v-b-tooltip
                                    title="Imprimir Minuta"
                                  >
                                    <i class="fa fa-print"></i
                                  ></a>
                                  <a
                                    @click="onVinculaOcorrencia(item_trecho, 3)"
                                    v-b-tooltip
                                    title="Vincular Ocorrência"
                                    ><i class="fa fa-exclamation-triangle"></i
                                  ></a>
                                  <a
                                    @click="onEditTrecho(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.trecho.update'
                                      )
                                    "
                                    v-b-tooltip
                                    title="Alterar Trecho"
                                    ><i class="fa fa-edit"></i
                                  ></a>
                                  <a
                                    @click="onCalcularTrecho(item_trecho)"
                                    v-if="
                                      getPermissionFw(
                                        'gerenciamentotransporte.trecho.update'
                                      ) && item_trecho.fornecedor.tp_fornecedor != 2
                                    "
                                    v-b-tooltip
                                    title="Calcular Trecho"
                                    ><i class="fa fa-calculator"></i
                                  ></a>
                                  <a
                                    @click="
                                      onDetailUnidadeCargaTrechoCusto(
                                        item_trecho.peduncatr_id
                                      )
                                    "
                                    v-if="
                                      item_trecho.pedido_unidade_carga_tre_custo
                                        .length > 0
                                    "
                                    v-b-tooltip
                                    title="Ver detalhes"
                                    ><i class="fa fa-plus"></i
                                  ></a>
                                </td>
                              </tr>
                              <tr
                                v-if="
                                  isVisibleDetailRowTrechoCusto(
                                    item_trecho.peduncatr_id
                                  )
                                "
                              >
                                <td colspan="10">
                                  <section class="tabs-section">
                                    <ul
                                      class="
                                        nav nav-tabs nav-topline nav-justified
                                      "
                                      role="tablist"
                                    >
                                      <li class="nav-item">
                                        <a
                                          class="nav-link active"
                                          v-bind:href="
                                            '#trc1' +
                                            item_trecho.peduncatr_id +
                                            ''
                                          "
                                          role="tab"
                                          data-toggle="tab"
                                        >
                                          <span class="nav-link-in">
                                            Custos
                                            <i class="fa fa-money"></i>
                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                    <div class="tab-content">
                                      <div
                                        role="tabpanel"
                                        class="
                                          tab-pane
                                          fade
                                          in
                                          active
                                          show
                                          pt-1
                                          border-color-detalhes-grey
                                        "
                                        v-bind:id="
                                          'trc1' + item_trecho.peduncatr_id + ''
                                        "
                                      >
                                        <table
                                          :class="[
                                            'vuetable table table-striped tbl-typical',
                                          ]"
                                        >
                                          <thead>
                                            <tr>
                                              <th style="width: 30%">
                                                Nº Custo
                                              </th>
                                              <th style="width: 30%">
                                                Descrição
                                              </th>
                                              <th style="width: 10%">
                                                Tipo Custo
                                              </th>
                                              <th style="width: 10%">Custo</th>
                                              <th style="width: 10%">Valor</th>
                                              <th style="width: 5%">Status</th>
                                              <th style="width: 5%">Ações</th>
                                            </tr>
                                          </thead>
                                          <tbody
                                            v-for="item_tre_custo in item_trecho.pedido_unidade_carga_tre_custo"
                                          >
                                            <tr
                                              class="bg-gray-light"
                                              style="display: table-row"
                                            >
                                              <td>
                                                {{ item_tre_custo.num_custo }}
                                              </td>
                                              <td>
                                                {{ item_tre_custo.descr }}
                                              </td>
                                              <td>
                                                {{
                                                  item_tre_custo.tp_custo.descr
                                                }}
                                              </td>
                                              <td>
                                                {{ item_tre_custo.custo.descr }}
                                              </td>
                                              <td>
                                                {{
                                                  formatNumber(
                                                    item_tre_custo.vlr_custo
                                                  )
                                                }}
                                              </td>
                                              <td>
                                                <span
                                                  class="badge badge-success"
                                                  v-if="
                                                    item_tre_custo.status
                                                      .valor == 1
                                                  "
                                                  >{{
                                                    item_tre_custo.status.descr
                                                  }}</span
                                                >
                                                <span
                                                  class="badge badge-danger"
                                                  v-if="
                                                    item_tre_custo.status
                                                      .valor == 2
                                                  "
                                                  >{{
                                                    item_tre_custo.status.descr
                                                  }}</span
                                                >
                                              </td>
                                              <td>
                                                <a
                                                  @click="
                                                    onEditCusto(item_tre_custo)
                                                  "
                                                  v-if="
                                                    getPermissionFw(
                                                      'gerenciamentotransporte.custo.update'
                                                    )
                                                  "
                                                  v-b-tooltip
                                                  title="Alterar Custo"
                                                  ><i class="fa fa-edit"></i
                                                ></a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </section>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </section>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t4' + rowData.carga_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 100%">Observação</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.obs }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-if="rowData.ocorrencias.length > 0"
          v-bind:id="'t5' + rowData.carga_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Tipo</th>
                <th style="width: 10%">Ocorrência</th>
                <th style="width: 10%">Data Ocorrência</th>
                <th style="width: 10%">N ° Docmento</th>
                <th style="width: 10%">Série</th>
                <th style="width: 10%">Dt Emissão</th>
                <th style="width: 10%">N ° Fiscal</th>
                <th style="width: 10%">Série</th>
                <th style="width: 10%">Dt Emissão</th>
                <th style="width: 10%">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.ocorrencias"
              >
                <td>
                  <span
                    v-if="item.docfis_id !== null"
                    class="badge badge-primary"
                    >Documento</span
                  >
                  <span
                    v-if="item.pedunicar_id !== null"
                    class="badge badge-warning"
                    >Unidade Carga</span
                  >
                  <span
                    v-if="item.peduncatr_id !== null"
                    class="badge badge-danger"
                    >Trecho</span
                  >
                </td>
                <td>
                  {{ item.param_ocorrencia.descr }}
                </td>
                <td>
                  {{ formatDate(item.dt_ocorrencia) }}
                </td>
                <td>
                  <span v-if="item.doc != null">
                    {{ item.doc.num_fiscal }}
                  </span>
                </td>
                <td>
                  <span v-if="item.doc != null">
                    {{ item.doc.serie }}
                  </span>
                </td>
                <td>
                  <span v-if="item.doc != null">
                    {{ formatDate(item.doc.dt_emi) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.doc_fiscal != null">
                    {{ item.doc_fiscal.num_fiscal }}
                  </span>
                </td>
                <td>
                  <span v-if="item.doc_fiscal != null">
                    {{ item.doc_fiscal.serie }}
                  </span>
                </td>
                <td>
                  <span v-if="item.doc_fiscal != null">
                    {{ formatDate(item.doc_fiscal.dt_emissao) }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t6' + rowData.carga_id + ''"
          v-if="rowData.carga_rota !== null"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 33%">Ordem do Pedágio</th>
                <th style="width: 33%">Nome</th>
                <th style="width: 33%">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.carga_rota.carga_rota_pedagio"
              >
                <td>
                  {{ item.ordem }}
                </td>
                <td>
                  {{ item.nome }}
                </td>
                <td>
                  {{ item.valor }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t7' + rowData.carga_id + ''"
          v-if="rowData.carga_rota !== null"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 33%">Descrição do Adiantamento</th>
                <th style="width: 33%">Valor</th>
                <th style="width: 33%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="rowData.despesa_carga != null">
                    {{ rowData.despesa_carga.despesa.descr }}
                    </span>
                </td>
                <td>
                  <span v-if="rowData.despesa_carga != null">
                    {{ rowData.despesa_carga.despesa.vlr }}
                    </span>
                </td>
                <td>
                  <a
                    @click="onAdiantar(rowData.despesa_carga)"
                    v-b-tooltip
                    title="Editar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
    <GerenciamentoTransporteAdiantamento
      ref="gerenciamentotransporteadiantamento"
    />
    <UnidadeCargaTrechoForm
      ref="unidadecargatrechoform"
    />
  </div>
</template>

  <script>
import accounting from "accounting";
import moment from "moment";
import GerenciamentoTransporteAdiantamento from "./GerenciamentoTransporteAdiantamento.vue";
import UnidadeCargaTrechoForm from "./UnidadeCargaTrechoForm.vue";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    GerenciamentoTransporteAdiantamento,
    UnidadeCargaTrechoForm,
  },
  data() {
    return {
      visibleDetailRowsTrecho: [],
      visibleDetailRowsTrechoCusto: [],
      form: new Form({
        trecho: [],
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onAdiantar(data) {
      this.$refs.gerenciamentotransporteadiantamento.onEdit(data);
    },
    onDetailUnidadeCargaTrecho(pedunicar_id) {
      this.toggleDetailRowTrecho(pedunicar_id);
    },
    isVisibleDetailRowTrecho(rowId) {
      return this.visibleDetailRowsTrecho.indexOf(rowId) >= 0;
    },
    showDetailRowTrecho(rowId) {
      if (!this.isVisibleDetailRowTrecho(rowId)) {
        this.visibleDetailRowsTrecho.push(rowId);
      }
    },
    hideDetailRowTrecho(rowId) {
      if (this.isVisibleDetailRowTrecho(rowId)) {
        this.visibleDetailRowsTrecho.splice(
          this.visibleDetailRowsTrecho.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowTrecho(rowId) {
      if (this.isVisibleDetailRowTrecho(rowId)) {
        this.hideDetailRowTrecho(rowId);
      } else {
        this.showDetailRowTrecho(rowId);
      }
    },
    /////////////////////////////////////////////////////////
    onDetailUnidadeCargaTrechoCusto(peuncatrcu_id) {
      this.toggleDetailRowTrechoCusto(peuncatrcu_id);
    },
    isVisibleDetailRowTrechoCusto(rowId) {
      return this.visibleDetailRowsTrechoCusto.indexOf(rowId) >= 0;
    },
    showDetailRowTrechoCusto(rowId) {
      if (!this.isVisibleDetailRowTrechoCusto(rowId)) {
        this.visibleDetailRowsTrechoCusto.push(rowId);
      }
    },
    hideDetailRowTrechoCusto(rowId) {
      if (this.isVisibleDetailRowTrechoCusto(rowId)) {
        this.visibleDetailRowsTrechoCusto.splice(
          this.visibleDetailRowsTrechoCusto.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowTrechoCusto(rowId) {
      if (this.isVisibleDetailRowTrechoCusto(rowId)) {
        this.hideDetailRowTrechoCusto(rowId);
      } else {
        this.showDetailRowTrechoCusto(rowId);
      }
    },
    onAlteraFornecedor(data) {
      this.$refs.fornecedorform.onEdit(data);
    },
    onAlteraStatus(data) {
      this.$refs.unidadecargatrechostatusform.onEdit(data);
    },
    onVinculaCusto(data) {
      this.$refs.unidadecargacustoform.onCreate(data);
    },
    onPrintMinuta(data) {
      this.form.trecho = [];
      this.form.trecho.push(data.peduncatr_id);
      this.form
        .post("/api/gerenciamentotransporte/calculo/imprimir")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onEditCusto(data) {
      this.$refs.unidadecargacustoform.onEdit(data);
    },
    onVinculaTrecho(data) {
      this.$refs.unidadecargatrechoform.onCreate(data);
    },
    onEditTrecho(data) {
      this.$refs.unidadecargatrechoform.onCalcularTrecho(data);
    },
    onCalcularTrecho(data) {
      this.$refs.unidadecargatrechoform.onCalcular(data);
    },
    onVinculaOcorrencia(data, tipo) {
      this.$refs.cargaocorrenciaform.onCreate(data, tipo);
    },
    ///////////////////////////////////////////////////////
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
  },
};
</script>